import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export const PasswordInput = ({ id, label, value, onChange, hint, autoComplete = "current-password", testid }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="space-y-2">
      <Label htmlFor={id}>{label}</Label>
      <div className="relative">
        <Input
          id={id}
          type={show ? "text" : "password"}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoComplete={autoComplete}
          className="pr-11"
          required
          aria-describedby={hint ? `${id}-hint` : undefined}
          data-testid={testid}
        />
        <button
          type="button"
          onClick={() => setShow((s) => !s)}
          className="absolute right-1 top-1 grid h-8 w-8 place-items-center rounded-lg text-muted-foreground transition-quick hover:bg-muted hover:text-foreground"
          aria-label={show ? "Hide password" : "Show password"}
          data-testid={`${testid}-toggle`}
        >
          {show ? <EyeOff className="!h-4 !w-4" /> : <Eye className="!h-4 !w-4" />}
        </button>
      </div>
      {hint && (
        <p id={`${id}-hint`} className="text-xs text-muted-foreground">
          {hint}
        </p>
      )}
    </div>
  );
};
